export default __webpack_public_path__ + "img/dahla_smartgrade.8aa5f768.png";